import type { RootState } from 'types'

const newProductList = (state: RootState) => state.product.newProducts
const productList = (state: RootState) => state.product.productList
const productDetails = (state: RootState) => state.product.product
const productOptons = (state: RootState) => state.product.productOptons

export const ProductSelectors = {
  productList,
  productOptons,
  newProductList,
  productDetails,
}
